module.exports = "<div class=row><div ng-include=\"'app/modules/trains-base/templates/flights/form_options/trains-travellers-dropdown.html'\"></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/train/directives/templates/travellers.tmpl.html
// module id = 3692
// module chunks = 0